<template>
  <div>
    <br />
    <v-row>
      <v-col cols="12" sm="5">
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-img src="/img/klik/IdMotor.svg"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>ID Motor</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>{{ detailMokas.id ? detailMokas.id : '-' }}</v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-avatar>
              <v-img src="/img/klik/Merek.svg"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Merek</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>{{
              detailMokas.merk ? detailMokas.merk : '-'
            }}</v-list-item-action>
          </v-list-item>

          <v-list-item>
            <v-list-item-avatar>
              <v-img src="/img/klik/Tipe.svg"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Tipe</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>{{
              detailMokas.type ? detailMokas.type : '-'
            }}</v-list-item-action>
          </v-list-item>
          <div v-if="selengkapnya">
            <v-list-item>
              <v-list-item-avatar>
                <v-img src="/img/klik/Tahun.svg"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>Tahun</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>{{
                detailMokas.tahun ? detailMokas.tahun : '-'
              }}</v-list-item-action>
            </v-list-item>

            <v-list-item v-if="detailMokas.odometer != null">
              <v-list-item-avatar>
                <v-img src="/img/klik/Odo.svg"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>Odometer</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                {{ detailMokas.odometer }} KM
              </v-list-item-action>
            </v-list-item>

            <v-list-item v-if="detailMokas.warna != null">
              <v-list-item-avatar>
                <v-img src="/img/klik/Warna.svg"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>Warna</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>{{ detailMokas.warna }}</v-list-item-action>
            </v-list-item>

            <v-list-item v-if="detailMokas.cc != null">
              <v-list-item-avatar>
                <v-img src="/img/klik/CC.svg"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>CC Mesin</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>{{ detailMokas.cc }} CC</v-list-item-action>
            </v-list-item>

            <v-list-item v-if="detailMokas.transmisi != null">
              <v-list-item-avatar>
                <v-img src="/img/klik/Tranmisi.svg"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>Transmisi</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                {{ detailMokas.transmisi }}
              </v-list-item-action>
            </v-list-item>

            <v-list-item v-if="detailMokas.jenis_motor != null">
              <v-list-item-avatar>
                <v-img src="/img/klik/Jenis.svg"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>Jenis Motor</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                {{ detailMokas.jenis_motor }}
              </v-list-item-action>
            </v-list-item>

            <v-list-item v-if="detailMokas.lokasi_samsat != null">
              <v-list-item-avatar>
                <v-img src="/img/klik/Lok.svg"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>Lokasi Samsat</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                {{ detailMokas.lokasi_samsat }}
              </v-list-item-action>
            </v-list-item>

            <v-list-item v-if="detailMokas.lokasi != null">
              <v-list-item-avatar>
                <v-img src="/img/klik/Lok.svg"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>Lokasi Motor</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>{{ detailMokas.lokasi }}</v-list-item-action>
            </v-list-item>
          </div>
        </v-list>
      </v-col>

      <v-divider vertical inset class="mx-4"></v-divider>

      <v-col cols="12" sm="6">
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-img src="/img/klik/Pajak.svg"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>STNK</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              {{ detailMokas.lembar_stnk ? 'Ada' : 'Tidak' }}
            </v-list-item-action>
          </v-list-item>

          <v-list-item v-if="detailMokas.tanggal_stnk != null">
            <v-list-item-avatar>
              <v-img src="/img/klik/Pajak.svg"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Tanggal STNK</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <!-- {{ moment.utc(detailMokas.tanggal_stnk).format('DD MMMM YYYY') }} -->
              {{ detailMokas.tanggal_stnk | dateFormat }}
            </v-list-item-action>
          </v-list-item>

          <v-list-item>
            <v-list-item-avatar>
              <v-img src="/img/klik/Pajak.svg"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Lembar Pajak</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              {{ detailMokas.lembar_pajak ? 'Ada' : 'Tidak' }}
            </v-list-item-action>
          </v-list-item>

          <div v-if="selengkapnya">
            <v-list-item v-if="detailMokas.tanggal_pajak != null">
              <v-list-item-avatar>
                <v-img src="/img/klik/Pajak.svg"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>Tanggal Pajak</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <!-- {{ moment.utc(detailMokas.tanggal_pajak).format('DD MMM YYYY') }} -->
                {{ detailMokas.tanggal_pajak | dateFormat }}
              </v-list-item-action>
            </v-list-item>

            <v-list-item>
              <v-list-item-avatar>
                <v-img src="/img/klik/Pajak.svg"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>BPKB</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                {{ detailMokas.lembar_bpkb ? 'Ada' : 'Tidak' }}
              </v-list-item-action>
            </v-list-item>
          </div>
        </v-list>
      </v-col>
    </v-row>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text  color="primary" @click="selengkapnya = false" v-if="selengkapnya"
        >Urungkan</v-btn
      >
      <v-btn text  color="primary" @click="selengkapnya = true" v-else>Selengkapnya</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'spesifikasi',
  props: ['detailMokas'],
  filters: {
    countDoc(doc) {
      if (doc !== null) {
        return true;
      }
    },
    datediff: (date) => {
      return moment(date).from();
    },
    dateFormat: (date) => {
      return moment.utc(date).format('DD MMM YYYY');
    },
    timeFormat: (date) => {
      return moment.utc(date).format('HH:mm');
    },
    dateTimeFormat: (date) => {
      return moment.utc(date).format('DD MMM YYYY HH:mm');
    },
  },
  data: () => ({
    selengkapnya: false,
  }),
};
</script>

<style>
</style>